<template>
  <div class="help-page">
    <TopBar />
    <div class="help-page-main">
      <div class="help-page-container">
        <h1>{{$t("PageCommon.HelpCenter")}}</h1>
        <div class="help-page-content">
        <div class="top-tabs">
          <ul>
            <li><router-link to='/Help/OperationManual'>{{$t("PageCommon.zhinan")}}</router-link></li>
            <li><router-link to='/Help/FAQ'>{{$t("PageCommon.faq")}}</router-link></li>
          </ul>
        </div>          
        <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TopBar } from '../layout/components'
export default {
  name: 'HelpLayout',
  components: {
    TopBar
  }
}
</script>

<style scoped>
.help-page{
  background-color: #F8F9FB;
}
.help-page-main{
  background-image: url('../assets/img/Help/help-bg.png');
  background-repeat: no-repeat;
  background-position: top center;
  background-size: auto 250px;
  background-color: #F8F9FB;
  padding-top: 50px;
  height: 100vh;
  min-height: 500px;
  overflow-y: auto;
}
.help-page-main h1{
  padding-top: 40px;
  padding-bottom: 40px;
  line-height: 30px;
  font-size: 24px;
  color: #333;
  font-weight: normal;
  background-image: url(../assets/img/Help/help-icon.svg);
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 30px auto;
  padding-left: 40px;
}
.help-page-container{
  width: 80%;
  margin: auto;
}
.help-page-content{
  width: 100%;
  padding: 40px;
  background-color: #fff;
}

.top-tabs{
  height: 40px;
  border-bottom: 1px solid #D6D6D6;
  margin-bottom: 40px;
}
.top-tabs ul{
  list-style: none;
  padding: 0;
  margin: 0;
}
.top-tabs ul li{
  float: left;
  margin-right: 30px;
  line-height: 39px;
}
.top-tabs ul li a{
  height: 40px;
  padding-left: 30px;
  display: block;
  font-size: 14px;
  color: #666;
  text-decoration: none;
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 20px auto;
}
.top-tabs ul li:first-child a{
  background-image: url('../assets/img/Help/icon/helpnormal.svg');
}
.top-tabs ul li:last-child a{
  background-image: url('../assets/img/Help/icon/faqnormal.svg');
}
.top-tabs ul li:first-child a.router-link-active{
  background-image: url('../assets/img/Help/icon/helpactive.svg');
  background-position: left 10px;
}
.top-tabs ul li:last-child a.router-link-active{
  background-image: url('../assets/img/Help/icon/faqactive.svg');
  background-position: left 10px;
}
.top-tabs ul li a.router-link-active{
  color:#CC454A;
  border-bottom: 2px solid #CC454A;
}

</style>